import { createSelector } from 'reselect';

export const getMessagesErrors = createSelector(
  (state) => state.messages.errors,
  (errors) => {
    return errors;
  }
);
